import React from 'react';
import Button from '../../uiToolkit/Buttons/Button';
import styles from './LearnersEmpty.module.css';

interface Props {
  title: string;
  text?: string;
  actionTitle?: string;
  onAction?: () => void;
}

const LearnersEmpty = React.memo(
  ({title, text, actionTitle, onAction}: Props) => {
    return (
      <div className={styles.container}>
        <span className={styles.badge}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#26625f"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M19 8v6M22 11h-6" />
          </svg>
        </span>
        <p className={styles.title}>{title}</p>
        {text && <p className={styles.text}>{text}</p>}
        {actionTitle && onAction && (
          <div className={styles.action}>
            <Button title={actionTitle} uiType="secondary" onClick={onAction} />
          </div>
        )}
      </div>
    );
  },
);

export default LearnersEmpty;
